/* eslint-disable */
/// This file is auto generated - do not edit manually
export const PersonalOfferTag = 'Website.PersonalOffer.Toggle.PersonalOfferTag';
export const ToggleActiveTag = 'Website.PersonalOffer.Toggle.ToggleActiveTag';
export const ToggleActiveText = 'Website.PersonalOffer.Toggle.ToggleActiveText';
export const ToggleNotActiveText = 'Website.PersonalOffer.Toggle.ToggleNotActiveText';
export const ToggleActivatedMessage = 'Website.PersonalOffer.Toggle.ToggleActivatedMessage';
export const ToggleOnErrorMessage = 'Website.PersonalOffer.Toggle.ToggleOnErrorMessage';
export const ToggleOffErrorMessage = 'Website.PersonalOffer.Toggle.ToggleOffErrorMessage';
export const TermsButtonText = 'Website.PersonalOffer.Toggle.TermsButtonText';
